module.exports = __webpack_public_path__ + "img/island-display.6a291b9c.png";